import useKeyboardEvent from './useKeyboardEvent';

export default useKeyboardEvent;
